var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPodiatry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.61 17.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#555;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_11",
    "data-name": "Layer 11"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 8.81,
    cy: 8.81,
    r: 8.81
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_15",
    "data-name": "Layer 15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rnYpe3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.93.59c0,.28-.12.54-.15.79-.1.88-.21,1.76-.29,2.64-.05.51-.05,1-.06,1.53A5,5,0,0,0,9.6,7,9,9,0,0,1,9.87,8.7c.06.66.16,1.32.25,2a.65.65,0,0,0,.17.33,2.73,2.73,0,0,0,.52.37q.78.39,1.59.75a.75.75,0,0,1,.4.7.19.19,0,0,1-.09.16,1.3,1.3,0,0,1-.23.15.58.58,0,0,1-.51.63,1.84,1.84,0,0,1-.84,0c-.71-.16-1.42-.31-2.12-.5a1.87,1.87,0,0,1-1.43-1.52c-.11-.51-.22-1-.34-1.52a1.43,1.43,0,0,0-.77-1.08,3,3,0,0,0-.84-.23,2.79,2.79,0,0,1-1.75-.82A1.72,1.72,0,0,1,3.35,6.7a1.51,1.51,0,0,1,.46-1,5.36,5.36,0,0,1,.74-.69A3.13,3.13,0,0,0,5.75,2.8c0-.45.09-.91.14-1.37A.17.17,0,0,1,6,1.29,8,8,0,0,1,9.32.54Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodiatry);
export default __webpack_public_path__ + "static/media/Podiatry.d4eb3223fe6ab19892fbffdbe6b51488.svg";
export { ForwardRef as ReactComponent };